"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkLevel = exports.registerStaffAsGuestFromExcel = exports.downloadStaffRegisterExcel = exports.updateStaff = exports.getOrCreateUser = exports.upgrade = exports.remove = exports.getIds = exports.getAll = exports.get = void 0;
/* eslint-disable no-undef */
var Staff_1 = require("@cck/common/dist/data/Staff");
var lodash_1 = __importDefault(require("lodash"));
var xlsx_1 = __importDefault(require("xlsx"));
var fbase_1 = __importStar(require("../firebase/fbase"));
var MailManager_1 = require("../mail/MailManager");
var ControlManager = __importStar(require("../rcm/ControlManager"));
var DepartmentManager = __importStar(require("../rcm/DepartmentManager"));
var StaffManager = __importStar(require("../rcm/StaffManager"));
var StorageManager_1 = require("../storage/StorageManager");
var UpdateContainer_1 = __importDefault(require("./UpdateContainer"));
var COLLECTION_NAME_GUEST = 'GUEST';
var COLLECTION_NAME_STAFF = 'STAFF';
var get = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
    var docData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(guestId).get()];
            case 1:
                docData = _a.sent();
                return [2 /*return*/, docData.data()];
        }
    });
}); };
exports.get = get;
var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME_GUEST).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, collectionData.docs.map(function (docData) { return docData.data(); })];
        }
    });
}); };
exports.getAll = getAll;
var getIds = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME_GUEST).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, collectionData.docs.map(function (docData) { return docData.id; })];
        }
    });
}); };
exports.getIds = getIds;
var create = function (registerObj) { return __awaiter(void 0, void 0, void 0, function () {
    var staffId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                staffId = registerObj.id.toLowerCase();
                return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(staffId).set({
                        id: staffId,
                        email: registerObj.id,
                        name: registerObj.name,
                        department: registerObj.department,
                        level: 'GUEST',
                        uid: '',
                        upgrade: false
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var remove = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
    var targetDocId, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                targetDocId = guestId;
                docRef = fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(targetDocId);
                return [4 /*yield*/, docRef.delete()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.remove = remove;
var getUid = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
    var docData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(guestId).get()];
            case 1:
                docData = (_a.sent()).data();
                return [2 /*return*/, docData ? docData.uid : ''];
        }
    });
}); };
var removeUid = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
    var targetDocId, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                targetDocId = guestId;
                docRef = fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(targetDocId);
                return [4 /*yield*/, docRef.update({ uid: '' })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateForCF = function (guestId) { return __awaiter(void 0, void 0, void 0, function () {
    var targetDocId, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                targetDocId = guestId;
                docRef = fbase_1.dbService.collection(COLLECTION_NAME_GUEST).doc(targetDocId);
                return [4 /*yield*/, docRef.update({ upgrade: true })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var upgrade = function (guest, projectId) { return __awaiter(void 0, void 0, void 0, function () {
    var uid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getUid(guest.id)];
            case 1:
                uid = _a.sent();
                removeUid(guest.id);
                guest.uid = uid;
                return [4 /*yield*/, StaffManager.create(guest)];
            case 2:
                _a.sent();
                return [4 /*yield*/, updateForCF(guest.id)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, MailManager_1.sendGuestJoinMail)([guest.id], projectId)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.upgrade = upgrade;
function getOrCreateUser() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var authService, staffData, guestData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    authService = fbase_1.default.auth();
                    if (!(authService === null || authService === void 0 ? void 0 : authService.currentUser) || !authService.currentUser.email) {
                        return [2 /*return*/, Promise.reject(new Error('Not login'))];
                    }
                    return [4 /*yield*/, StaffManager.get(authService.currentUser.email)];
                case 1:
                    staffData = _b.sent();
                    if (!!staffData) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, exports.get)(authService.currentUser.email)];
                case 2:
                    guestData = _b.sent();
                    if (!!guestData) return [3 /*break*/, 5];
                    return [4 /*yield*/, create({
                            id: authService.currentUser.email,
                            name: ((_a = authService.currentUser) === null || _a === void 0 ? void 0 : _a.displayName) || '',
                            department: ''
                        })];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, (0, exports.get)(authService.currentUser.email)];
                case 4:
                    guestData = _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/, guestData];
                case 6: return [2 /*return*/, staffData];
            }
        });
    });
}
exports.getOrCreateUser = getOrCreateUser;
var updateStaff = function (staffObject) { return __awaiter(void 0, void 0, void 0, function () {
    var userId, newName, newLevel, newDepartmentId, staffData, prevName, prevLevel, prevDepartmentId, targetDocId, docRef, departmentUpdateMap, staffs, adminData, adminId, errorMsg, staffs, adminData, adminId, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userId = staffObject.id;
                newName = staffObject.name;
                newLevel = staffObject.level;
                newDepartmentId = staffObject.department;
                return [4 /*yield*/, StaffManager.get(userId)];
            case 1:
                staffData = _a.sent();
                if (!staffData) {
                    return [2 /*return*/, Promise.reject(new Error('해당되는 유저가 없습니다.'))];
                }
                prevName = staffData.name;
                prevLevel = staffData.level;
                prevDepartmentId = staffData.departmentName;
                targetDocId = userId;
                docRef = fbase_1.dbService.collection(COLLECTION_NAME_STAFF).doc(targetDocId);
                if (!(newName !== prevName)) return [3 /*break*/, 3];
                return [4 /*yield*/, docRef.update({ name: newName })];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                if (!(newLevel !== prevLevel)) return [3 /*break*/, 16];
                if (!(newLevel === Staff_1.Level.BLOCKED)) return [3 /*break*/, 13];
                departmentUpdateMap = new UpdateContainer_1.default();
                departmentUpdateMap.del(prevDepartmentId, 'staffIds', userId);
                return [4 /*yield*/, DepartmentManager.updateMaps(departmentUpdateMap)];
            case 4:
                _a.sent();
                if (!(prevLevel === Staff_1.Level.ADMIN)) return [3 /*break*/, 8];
                return [4 /*yield*/, StaffManager.getAll()];
            case 5:
                staffs = _a.sent();
                adminData = lodash_1.default.filter(staffs, function (staff) {
                    var level = staff.level;
                    var id = staff.id;
                    return userId !== id && level === Staff_1.Level.ADMIN;
                });
                adminId = adminData === null || adminData === void 0 ? void 0 : adminData[0].id;
                if (lodash_1.default.isEmpty(adminId)) {
                    errorMsg = 'Error. CONTROL 을 이관할 또 다른 ADMIN 이 존재하지 않습니다.';
                    return [2 /*return*/, Promise.reject(new Error(errorMsg))];
                }
                return [4 /*yield*/, docRef.update({ level: newLevel, departmentName: '', departmentIds: [] })];
            case 6:
                _a.sent();
                return [4 /*yield*/, ControlManager.updateMapWithAdmin(userId, adminId)];
            case 7:
                _a.sent();
                return [2 /*return*/, { adminId: adminId }];
            case 8:
                if (!(prevLevel === Staff_1.Level.NORMAL ||
                    prevLevel === Staff_1.Level.UPLOADER ||
                    prevLevel === Staff_1.Level.WATCHER)) return [3 /*break*/, 12];
                return [4 /*yield*/, StaffManager.getAll()];
            case 9:
                staffs = _a.sent();
                adminData = lodash_1.default.filter(staffs, { level: 'ADMIN' });
                adminId = adminData === null || adminData === void 0 ? void 0 : adminData[0].id;
                if (lodash_1.default.isEmpty(adminId)) {
                    errorMsg = 'Error. CONTROL 을 이관할 ADMIN 이 존재하지 않습니다.';
                    return [2 /*return*/, Promise.reject(new Error(errorMsg))];
                }
                return [4 /*yield*/, docRef.update({ level: newLevel, departmentName: '', departmentIds: [] })];
            case 10:
                _a.sent();
                return [4 /*yield*/, ControlManager.updateMapWithAdmin(userId, adminId)];
            case 11:
                _a.sent();
                return [2 /*return*/, { adminId: adminId }];
            case 12: return [3 /*break*/, 15];
            case 13: return [4 /*yield*/, docRef.update({ level: newLevel })];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [2 /*return*/];
            case 16:
                if (!(newDepartmentId !== prevDepartmentId)) return [3 /*break*/, 19];
                // 부서를 변경하면 연결된 다양한 내용들이 바뀌어야한다
                // 해당 유저가 들고 있는 컨트롤들을 이전부서의 controlPathArray에서 삭제
                // 해당 유저가 들고 있는 컨트롤들을 새로운 부서의 controlPathArray 에 추가
                // 각 컨트롤에서 controlDepartment, departmentPathArray 변경
                // 설계평가 보고서 업데이트
                return [4 /*yield*/, StaffManager.updateMapWithDepartment(userId, newDepartmentId)];
            case 17:
                // 부서를 변경하면 연결된 다양한 내용들이 바뀌어야한다
                // 해당 유저가 들고 있는 컨트롤들을 이전부서의 controlPathArray에서 삭제
                // 해당 유저가 들고 있는 컨트롤들을 새로운 부서의 controlPathArray 에 추가
                // 각 컨트롤에서 controlDepartment, departmentPathArray 변경
                // 설계평가 보고서 업데이트
                _a.sent();
                return [4 /*yield*/, docRef.update({
                        departmentName: newDepartmentId,
                        departmentIds: [newDepartmentId]
                    })];
            case 18:
                _a.sent();
                _a.label = 19;
            case 19: return [2 /*return*/];
        }
    });
}); };
exports.updateStaff = updateStaff;
// export const adminDownloadStaffRegisterTemplateExcel = async (): Promise<void> => {
var downloadStaffRegisterExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
    var fileName, fullFilePath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fileName = '직원 업로드 Template.xlsx';
                fullFilePath = 'Template/직원 업로드 Template.xlsx';
                return [4 /*yield*/, (0, StorageManager_1.saveFromStorage)(fullFilePath, fileName)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.downloadStaffRegisterExcel = downloadStaffRegisterExcel;
var parseStaffRegisterExcel = function (excelFile) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // Admin 페이지에서 Staff Register 를 위한 엑셀 파싱
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var fileReader = new FileReader();
                fileReader.onloadend = function (evt) { return __awaiter(void 0, void 0, void 0, function () {
                    var targetExcelFile, excelData, wsName, ws, range, jsonExcelData, guestEmailList, staffEmailList, parsingResult;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                targetExcelFile = evt.target.result;
                                excelData = xlsx_1.default.read(targetExcelFile, { type: 'binary' });
                                wsName = excelData.SheetNames[0];
                                ws = excelData.Sheets[wsName];
                                // to get header row
                                // set range.s.r = row number(=== header row) - 1
                                if (!ws || !ws['!ref']) {
                                    return [2 /*return*/];
                                }
                                range = xlsx_1.default.utils.decode_range(ws['!ref']);
                                range.s.r = -1;
                                ws['!ref'] = xlsx_1.default.utils.encode_range(range);
                                jsonExcelData = xlsx_1.default.utils.sheet_to_json(ws, { defval: '' });
                                jsonExcelData = jsonExcelData.slice(1); // except for header row
                                return [4 /*yield*/, (0, exports.getIds)()];
                            case 1:
                                guestEmailList = _a.sent();
                                return [4 /*yield*/, StaffManager.getIds()];
                            case 2:
                                staffEmailList = _a.sent();
                                parsingResult = [];
                                jsonExcelData.forEach(function (rowData) {
                                    var tempRowData = {
                                        error: false,
                                        errorMsg: '',
                                        department: '',
                                        name: '',
                                        email: ''
                                    };
                                    lodash_1.default.forEach(Object.values(rowData), function (v, index) {
                                        if (index === 0) {
                                            // 부서
                                            v = v.trim();
                                            tempRowData.department = v;
                                        }
                                        else if (index === 1) {
                                            // 이름
                                            v = v.trim();
                                            tempRowData.name = v;
                                        }
                                        else if (index === 2) {
                                            // 이메일
                                            v = v.trim();
                                            tempRowData.email = v;
                                        }
                                    });
                                    var emailString = tempRowData.email;
                                    var nameString = tempRowData.name;
                                    var departmentString = tempRowData.department;
                                    if (emailString === '' || nameString === '' || departmentString === '') {
                                        tempRowData.error = true;
                                        tempRowData.errorMsg = '값이 없는 필드가 존재합니다.';
                                        parsingResult.push(tempRowData);
                                    }
                                    else if (!emailString.includes('@')) {
                                        tempRowData.error = true;
                                        tempRowData.errorMsg = '잘못된 이메일 주소입니다.';
                                        parsingResult.push(tempRowData);
                                    }
                                    else if (guestEmailList.includes(emailString.toLowerCase())) {
                                        tempRowData.error = true;
                                        tempRowData.errorMsg = 'GUEST 에 이미 등록된 이메일 주소입니다.';
                                        parsingResult.push(tempRowData);
                                    }
                                    else if (staffEmailList.includes(emailString.toLowerCase())) {
                                        tempRowData.error = true;
                                        tempRowData.errorMsg = '직원에 이미 등록된 이메일 주소입니다.';
                                        parsingResult.push(tempRowData);
                                    }
                                    else {
                                        parsingResult.push(tempRowData);
                                    }
                                });
                                resolve(parsingResult);
                                return [2 /*return*/];
                        }
                    });
                }); };
                fileReader.onerror = reject;
                fileReader.readAsBinaryString(excelFile);
            })];
    });
}); };
var registerStaffAsGuestFromExcel = function (fileObject) { return __awaiter(void 0, void 0, void 0, function () {
    var excelParsingResult, errorList;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, parseStaffRegisterExcel(fileObject)
                // 결과에 에러가 있는지부터 파악
            ];
            case 1:
                excelParsingResult = _a.sent();
                errorList = [];
                excelParsingResult.forEach(function (staffObject) {
                    if (staffObject.error) {
                        errorList.push(staffObject);
                    }
                });
                if (errorList.length > 0) {
                    // 에러가 있는것이 존재
                    // 이경우에 어떻게 할것인가
                    // 일단은 에러가 있는경우 등록을 모두 안하고 에러를 띄우는 것으로
                    return [2 /*return*/, Promise.reject(new Error(errorList[0].errorMsg))];
                }
                // 에러가 없다면 등록
                // 이제는 바뀌어서 실제 Firebase Auth에 등록하지 않고 GUEST 에 값을 집어넣는 것만 여기서 처리
                return [4 /*yield*/, Promise.all(excelParsingResult.map(function (staffObject) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, create({
                                        id: staffObject.email,
                                        name: staffObject.name,
                                        department: staffObject.department
                                    })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                // 에러가 없다면 등록
                // 이제는 바뀌어서 실제 Firebase Auth에 등록하지 않고 GUEST 에 값을 집어넣는 것만 여기서 처리
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.registerStaffAsGuestFromExcel = registerStaffAsGuestFromExcel;
var checkLevel = function (staffId) { return __awaiter(void 0, void 0, void 0, function () {
    var result, staffData, level;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = false;
                return [4 /*yield*/, StaffManager.get(staffId)];
            case 1:
                staffData = (_a.sent());
                level = staffData.level;
                if (level === 'ADMIN') {
                    result = true;
                }
                return [2 /*return*/, result];
        }
    });
}); };
exports.checkLevel = checkLevel;
//# sourceMappingURL=Admin.js.map